import { makeStyles } from "tss-react/mui";

import { Theme as MuiTheme } from "@mui/material";
import Box from "@mui/material/Box";
import CircularProgress, { CircularProgressProps } from "@mui/material/CircularProgress";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles()((muiTheme: MuiTheme) => ({
    container: { width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" },
    circularBox: { position: "relative", display: "inline-flex" },
    labelBox: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    },
    label: { color: muiTheme.palette.emteria.text.secondary },
}));

type Props = Omit<CircularProgressProps, "size"> & {
    value?: number;
    size: "small" | "regular" | "large";
};

export const CircularProgressBox = (props: Props) => {
    const { classes } = useStyles();
    const theme = useTheme();
    const { value, size, ...rest } = props;

    let circularSize;
    let fontSize;

    switch (size) {
        case "small":
            circularSize = 40;
            fontSize = 10;
            break;
        case "large":
            circularSize = 70;
            fontSize = 16;
            break;
        default:
            circularSize = 55;
            fontSize = 14;
    }

    const isDeterminate = value !== undefined;

    return (
        <Box className={classes.container}>
            <Box className={classes.circularBox}>
                <CircularProgress
                    {...rest}
                    variant={isDeterminate ? "determinate" : "indeterminate"}
                    value={value}
                    size={circularSize}
                    sx={{ color: theme.palette.emteria.primary }}
                />
                {isDeterminate && (
                    <Box className={classes.labelBox}>
                        <Typography style={{ fontSize }} className={classes.label}>{`${Math.round(value)}%`}</Typography>
                    </Box>
                )}
            </Box>
        </Box>
    );
};
